// extracted by mini-css-extract-plugin
module.exports =  {"subHeader":"subHeader__k2os-","subHeaderTextTitle":"subHeaderTextTitle__yd4EI","subHeaderTextSubTitle":"subHeaderTextSubTitle__nve7q"};